import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DirectPayComponent } from './components/direct-pay/direct-pay.component';
import { ReceiptComponent } from '../public-shared/receipt/receipt.component';

const buyerRoutes: Routes = [
  {
    path: 'gate',
    loadChildren: () => import('./components/Gate/gate-success-failure.module').then(m => m.CashSuccessBuyerModule) },
  {
    path: 'callbacks',
    loadChildren: () => import('./components/card-payments-callbacks/card-payments-callbacks.module').then(m => m.CardPaymentsCallbacksModule ) },
    {
      path: "pay",
      loadChildren: () => import('./components/public-payment/public-payment.module').then(m => m.PublicPaymentModule)
    },
  {
    path: ':pattern',
    loadChildren: () => import('./components/buyer-container/buyer-container.module').then(m => m.BuyerContainerModule) },
  {
    path: ':pattern/buyerinfo',
    loadChildren: () => import('./components/buyer-info/buyer-info.module').then(m => m.BuyerInfoModule)
  },
  {
    path: 'receipt/:trxRefNum',
    component: ReceiptComponent
  },
  {
    path: ":pattern/pay",
    loadChildren: () => import('./components/free-payment/free-payment.module').then(m => m.FreePaymentModule)
  },
  {
    path: "cash/success",
    loadChildren: () => import('./components/quick-cash-sucess-buyer/cash-success-buyer.module').then(m => m.CashSuccessBuyerModule) },
  {
    path: "fawry/success",
    loadChildren: () => import('./components/fawry-success-buyer/fawry-success-buyer.module').then(m => m.FawrySuccessBuyerModule) },
  {
    path: "valu/:pattern",
    loadChildren: () => import('./components/ValU/valU-success-buyer.module').then(m => m.ValUSuccessBuyerModule) },
  ];

@NgModule({
  imports: [RouterModule.forChild(buyerRoutes)],
  exports: [RouterModule]
})
export class BuyerRoutingModule { }
